import LayoutPageInvoiceView from "./layout/index";
import { RouterItemType } from "@/app/module/router/index";
import { serviceBillingApi } from "@/services/billing/index";

const loaderDataInvoiceView = async (args: any) => {
  try {
    const { invoiceId } = args.params;

    if (!invoiceId) {
      throw new Error("INVOICE_ID_REQUIRED");
    }

    const invoice = serviceBillingApi.fetchBillingInvoiceById(invoiceId);

    if (!invoice) {
      throw new Error("INVOICE_NOT_FOUND");
    }

    return invoice;
  } catch (err) {
    console.log(err);
  }
};

export const routerPageInvoiceView: RouterItemType = {
  path: "/billing/invoices/:invoiceId",
  authorize: true,
  element: <LayoutPageInvoiceView />,
  loader: loaderDataInvoiceView,
};
